import envVariables from '../envVariables';

//backend
const CREDENTIALS_FOR_LOGGING = '/user/get-credentials-for-logging';
const ANONYMOUS_GENERATE_TOKEN = '/anonymous/generate-token';
const ANONYMOUS_PUSH_LOGS = '/anonymous/push-logs';
const CREATE_SESSION = '/user/session-management/create-session';
const GET_CURRENT_SESSION = '/user/session-management/get-current-session';
const LOGOUT_SESSION = '/user/logout';
const RATINGS_IMPRESSION = '/ratings/impression';
const RATINGS_SUBMIT = '/ratings/submit';
//
const CONSENTS = `{0}/${envVariables.APP_TYPE}`;
//
const LOCALIZATION = `${envVariables.APP_TYPE}/{0}.json`;
const GENERAL_CONFIG = `${envVariables.APP_TYPE}/app_config.json`;
const MARKET_CONFIG = `${envVariables.APP_TYPE}/{0}_market_config.json`;
const USER_GROUPS_CONFIG = `${envVariables.APP_TYPE}/user_groups_config.json`;
const TARGET_GROUPS_CONFIG = `${envVariables.APP_TYPE}/target_groups_config.json`;
const COUNTRY_CODE = `country_code`;

export default {
    CREDENTIALS_FOR_LOGGING,
    ANONYMOUS_GENERATE_TOKEN,
    ANONYMOUS_PUSH_LOGS,
    CONSENTS,
    LOCALIZATION,
    GENERAL_CONFIG,
    MARKET_CONFIG,
    USER_GROUPS_CONFIG,
    TARGET_GROUPS_CONFIG,
    COUNTRY_CODE,
    CREATE_SESSION,
    GET_CURRENT_SESSION,
    LOGOUT_SESSION,
    RATINGS_IMPRESSION,
    RATINGS_SUBMIT,
};
